import { CREATE_CONTACT } from "../actions.type";
import ApiService from "@/common/api.service";

const state = {};
const getters = {};

const actions = {
  [CREATE_CONTACT](context, data) {
    let ex = {
      message: "ok"
    };
    return ApiService.post("website/createContact", data, ex);
  }
};

const mutations = {};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/website.module.js